package com.appsyde.shared.presentation.screen.screen.inbox

import androidx.compose.runtime.Composable
import com.appsyde.shared.presentation.style.animations.AppStylesAnimations
import com.appsyde.shared.presentation.style.style.AppStylesGlobal
import com.appsyde.shared.presentation.style.style.AppStylesHeader
import com.appsyde.shared.presentation.style.style.AppStylesLayout
import com.appsyde.shared.presentation.style.style.AppStylesWizard
import org.jetbrains.compose.web.css.Style
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.StyleSheet
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.marginTop
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.paddingBottom
import org.jetbrains.compose.web.css.paddingLeft
import org.jetbrains.compose.web.dom.*

private object PermissionViewStyles : StyleSheet() {
    val permissionBulletList by style {
        marginTop(8.px)
        paddingLeft(20.px)
        property("list-style-type", "disc")
    }
    /** Plus d'air au-dessus du divider (liste → 32px → divider). */
    val permissionCardHeaderBottom by style {
        paddingBottom(32.px)
    }
    /** Bloc confiance : 16px sous le divider, 24px au-dessus des boutons. */
    val permissionTrustSection by style {
        padding(16.px, 32.px, 24.px, 32.px)
    }
    val permissionTrustTitle by style {
        fontWeight(600)
        marginBottom(4.px)
    }
    /** Bloc actions : 24px sous le texte confiance, 8px sous les boutons. */
    val permissionFooter by style {
        padding(24.px, 32.px, 8.px, 32.px)
    }
}

private val DEFAULT_BODY_BULLETS = listOf(
    "afficher vos tickets",
    "préparer les réponses IA",
    "envoyer vos réponses aux clients"
)

@Composable
fun InboxPermissionsRequiredView(
    onGrantPermissions: () -> Unit,
    onLogout: (() -> Unit)? = null,
    title: String = "Autorisez l'accès à Gmail",
    bodyText: String? = null,
    bodyBullets: List<String>? = DEFAULT_BODY_BULLETS,
    primaryButtonLabel: String = "Donner les permissions",
    showPrimaryButton: Boolean = true,
) {
    Style(AppStylesAnimations)
    Style(AppStylesGlobal)
    Style(AppStylesHeader)
    Style(AppStylesLayout)
    Style(AppStylesWizard)
    Style(PermissionViewStyles)

    Div(attrs = { classes(AppStylesGlobal.appRoot) }) {

        // Header : logo + caption (comme l'écran invite)
        Div(attrs = { classes(AppStylesHeader.header) }) {
            Div(attrs = { classes(AppStylesHeader.wizardHeaderInner) }) {
                Div(attrs = { classes(AppStylesHeader.brandRow) }) {
                    Img("/appsydeIcon.png", attrs = {
                        classes(AppStylesHeader.brandIcon)
                        attr("alt", "AppSyde")
                    })
                    Div(attrs = { classes(AppStylesHeader.brandCol) }) {
                        Div(attrs = { classes(AppStylesHeader.brand) }) { Text("AppSyde") }
                        Span(attrs = { classes(AppStylesHeader.brandSubtitle) }) {
                            Text("Autorisation Gmail")
                        }
                    }
                }
                Span() {}
                Span() {}
            }
        }

        // Contenu : card centrale (même structure que wizard onboarding)
        Div(attrs = {
            classes(
                AppStylesGlobal.global,
                AppStylesLayout.globalContentWrap,
                AppStylesLayout.wizardPageWrap
            )
        }) {
            Div(attrs = { classes(AppStylesLayout.wizardContentWrapCentered) }) {
                Div(attrs = { classes(AppStylesLayout.wizardCardWrap) }) {
                    Div(attrs = { classes(AppStylesWizard.wizardCard) }) {
                        Div(attrs = { classes(AppStylesWizard.wizardCardInner, AppStylesAnimations.pageReveal) }) {
                            Div(attrs = { classes(AppStylesWizard.wizardCardHeader, PermissionViewStyles.permissionCardHeaderBottom) }) {
                                Span(attrs = { classes(AppStylesWizard.wizardHeroIcon) }) {
                                    Text("🔒")
                                }
                                Div(attrs = { classes(AppStylesWizard.wizardTitle) }) {
                                    Text(title)
                                }
                                Div(attrs = { classes(AppStylesWizard.wizardSubWrap) }) {
                                    if (bodyBullets != null) {
                                        Div(attrs = { classes(AppStylesWizard.wizardSub) }) {
                                            Text("AppSyde a besoin d'un accès à votre boîte Gmail pour :")
                                        }
                                        Ul(attrs = { classes(AppStylesWizard.wizardSub, PermissionViewStyles.permissionBulletList) }) {
                                            bodyBullets.forEach { bullet ->
                                                Li { Text(bullet) }
                                            }
                                        }
                                    } else {
                                        bodyText?.let { text ->
                                            Div(attrs = { classes(AppStylesWizard.wizardSub) }) {
                                                Text(text)
                                            }
                                        }
                                    }
                                }
                            }
                            Div(attrs = { classes(AppStylesWizard.wizardCardBody, PermissionViewStyles.permissionTrustSection) }) {
                                Div(attrs = { classes(AppStylesWizard.wizardSub, PermissionViewStyles.permissionTrustTitle) }) {
                                    Text("Vous gardez le contrôle")
                                }
                                Div(attrs = { classes(AppStylesWizard.wizardSub) }) {
                                    Text("AppSyde n'accède qu'aux informations nécessaires au support.")
                                }
                            }
                            Div(attrs = { classes(AppStylesWizard.wizardCardFooter, PermissionViewStyles.permissionFooter) }) {
                                if (onLogout != null) {
                                    Button(attrs = {
                                        classes(AppStylesWizard.wizardBtnSecondary)
                                        attr("type", "button")
                                        onClick { onLogout() }
                                    }) { Text("Déconnexion") }
                                }
                                if (showPrimaryButton) {
                                    Button(attrs = {
                                        classes(AppStylesWizard.wizardBtnPrimary)
                                        attr("type", "button")
                                        onClick { onGrantPermissions() }
                                    }) { Text(primaryButtonLabel) }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
